import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

export const OPTIMAL_DEBOUNCE_TIME = 500;

/** Debounces and DistinctUntilChanged a subject and subscribe to that */
export const subscribeSubject = (component, subject, next, debTime = OPTIMAL_DEBOUNCE_TIME) => {
  component['$subscribeTo'](
    subject.asObservable().pipe(
      debounceTime(debTime),
      distinctUntilChanged()
    ),
    next
  );
}
/** Non Distinct Subscription. Use for mainly Scrolling. Debounces a subject and subscribe to that */
export const subscribeSubjectND = (component, subject, next, debTime = OPTIMAL_DEBOUNCE_TIME) => {
  component['$subscribeTo'](
    subject.asObservable().pipe(
      debounceTime(debTime),
    ),
    next
  );
}
/** Debounces a subject by default 500ms and subscribe to that */
export const debounceSubject = (component, subject, next, waitTime = OPTIMAL_DEBOUNCE_TIME) => {
  component['$subscribeTo'](
    subject.asObservable().pipe(
      debounceTime(waitTime),
    ),
    next
  );
}


window.subscribeSubject = subscribeSubject;
window.Subject = new Subject();
